import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Root from '../components/root';
import * as CommonAction from '../actions/commonAction';

function mapStateToProps(state) {
  // const {
  //   initData, 
  //   consentData, 
  //   completedStepsData, 
  //   panVerificationRes,
  //   captchaRes,
  //   otpRes,
  //   otpMaxLimitExceededData,
  //   submitOTPData,
  //   videoLinkData,
  //   zipCodeDataRes,
  //   // mobVerificationGenerateOtp
  // } = state.Root;

  return {
    // ...state,
    ...state.Root
    // initData,
    // consentData,
    // completedStepsData,
    // panVerificationRes,
    // captchaRes,
    // otpRes,
    // otpMaxLimitExceededData,
    // submitOTPData,
    // videoLinkData,
    // zipCodeDataRes
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...CommonAction
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Root);
